export const ADD_EXAM_REQUEST = 'ADD_EXAM_REQUEST'
export const ADD_EXAM_SUCCESS = 'ADD_EXAM_SUCCESS'
export const ADD_EXAM_FALIURE = 'ADD_EXAM_FALIURE'
